import React from "react";
import { useLanguage } from "@/App";
import { ArrowLeft } from "lucide-react";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

const Disclaimer = () => {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <Navigation />
      <div className="pt-32 pb-24 max-w-4xl mx-auto px-6 md:px-12">
        <a href="/" className="inline-flex items-center gap-2 text-[#FF6B00] text-sm font-bold mb-8 hover:underline">
          <ArrowLeft size={16} />
          {language === "nl" ? "Terug naar home" : "Back to home"}
        </a>

        <h1 className="text-4xl sm:text-5xl font-black text-white mb-8" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
          Disclaimer
        </h1>

        <div className="prose prose-invert prose-zinc max-w-none space-y-8 text-zinc-300 leading-relaxed">
          {language === "nl" ? (
            <>
              <p className="text-zinc-400 text-sm">Laatst bijgewerkt: {new Date().toLocaleDateString("nl-NL", { year: "numeric", month: "long", day: "numeric" })}</p>

              <section>
                <h2 className="text-xl font-bold text-white mt-8 mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Algemeen</h2>
                <p>De informatie op deze website is met de grootste zorg samengesteld door EG Solutions. Desondanks is het mogelijk dat informatie op deze website onvolledig of onjuist is. EG Solutions is niet aansprakelijk voor enige schade die direct of indirect ontstaat door gebruik van de informatie op deze website.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mt-8 mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Geen garantie</h2>
                <p>EG Solutions garandeert niet dat deze website foutloos of ononderbroken functioneert. Wij spannen ons in om de website zo actueel en correct mogelijk te houden, maar geven geen garanties met betrekking tot de volledigheid, juistheid of actualiteit van de aangeboden informatie.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mt-8 mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Externe links</h2>
                <p>Deze website kan links bevatten naar externe websites. EG Solutions is niet verantwoordelijk voor de inhoud of het privacybeleid van deze externe websites.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mt-8 mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Intellectueel eigendom</h2>
                <p>Alle content op deze website, inclusief maar niet beperkt tot teksten, afbeeldingen, logo's, en software, is eigendom van EG Solutions en beschermd door auteursrecht en andere intellectuele eigendomsrechten. Niets van deze website mag worden gekopieerd, gereproduceerd of hergebruikt zonder schriftelijke toestemming van EG Solutions.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mt-8 mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Resultaten en cijfers</h2>
                <p>De op deze website genoemde resultaten, statistieken en cijfers zijn gebaseerd op gemiddelden en eerdere projecten. Individuele resultaten kunnen variëren. Genoemde cijfers zijn indicatief en vormen geen garantie voor toekomstige prestaties.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mt-8 mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Wijzigingen</h2>
                <p>EG Solutions behoudt zich het recht voor om de inhoud van deze disclaimer te allen tijde te wijzigen zonder voorafgaande kennisgeving.</p>
              </section>

              <section className="border-t border-white/10 pt-8 mt-12">
                <p>EG Solutions | Torenallee 101, 5617BR Eindhoven | KvK: 99681293</p>
              </section>
            </>
          ) : (
            <>
              <p className="text-zinc-400 text-sm">Last updated: {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</p>

              <section>
                <h2 className="text-xl font-bold text-white mt-8 mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>General</h2>
                <p>The information on this website has been compiled with the greatest care by EG Solutions. Nevertheless, information may be incomplete or incorrect. EG Solutions is not liable for any damage arising from the use of information on this website.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mt-8 mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>No Warranty</h2>
                <p>EG Solutions does not guarantee that this website will function error-free or uninterrupted. We strive to keep the website current and correct but make no guarantees regarding completeness, accuracy, or timeliness.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mt-8 mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>External Links</h2>
                <p>This website may contain links to external websites. EG Solutions is not responsible for the content or privacy policy of these external websites.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mt-8 mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Intellectual Property</h2>
                <p>All content on this website is owned by EG Solutions and protected by copyright. Nothing may be copied or reproduced without written permission.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mt-8 mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Results and Figures</h2>
                <p>Results, statistics, and figures mentioned on this website are based on averages and previous projects. Individual results may vary. Figures are indicative and do not guarantee future performance.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mt-8 mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Changes</h2>
                <p>EG Solutions reserves the right to modify this disclaimer at any time without prior notice.</p>
              </section>

              <section className="border-t border-white/10 pt-8 mt-12">
                <p>EG Solutions | Torenallee 101, 5617BR Eindhoven | CoC: 99681293</p>
              </section>
            </>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Disclaimer;
